import TopLayout from './TopLayout';

export const wrapRootElement = TopLayout;
